import { useEffect, useState } from 'react'
import { TriggerType } from '../../domain/enum/trigger-type.enum'
import { MissionTriggerModel } from '../../domain/model/mission-trigger.model'
import { MissionModel } from '../../domain/model/mission.model'
import { getTeam } from './team_helpers'

type IReplaceInstructionsTags = {
  mission: MissionModel;
  points: number;
}

export function groupIsComplete (mission:MissionModel) {
  let response: any = true
  response = !!mission?.responded
  mission?.childMissions?.forEach((item:MissionModel) => {
    if (response) {
      response = item.responded
    }
  })
  return response
}

export function groupIsCurrent (mission:MissionModel) {
  const response: any = []
  mission?.childMissions?.sort(orderByPosition).forEach((item:MissionModel) => {
    response.push(!!item.responded)
  })
  return (response.includes(false) && response.includes(true)) || response.every((item:any) => !item)
}

export function getCurrentMission (mission: MissionModel) {
  let response: MissionModel|null = null
  if (!mission.responded) {
    response = mission
  } else {
    mission?.childMissions?.sort(orderByPosition).forEach((item:MissionModel) => {
      if (!item.responded && !response) {
        response = item
      }
    })
  }
  return response
}

export function replaceTag (text: string, tag: string, newText: string) {
  return text.replace(tag, newText)
}

export function getTrigger (mission: MissionModel, type: TriggerType): MissionTriggerModel | undefined {
  return mission.missionTriggers.find(m => m.triggerType === type)
}

export function currentMissionIsParent (mission: MissionModel | null) {
  return mission?.isParent
}

export function currentMissionHasChild (mission: MissionModel | null) {
  return Number(mission?.childMissions.length) > 0
}

export function getCurrentIndexInGameMissions (mission: MissionModel | null, missionParentList: MissionModel[]): number {
  return missionParentList.findIndex((m: MissionModel) => m.uuid === mission?.uuid)
}

export function getCurrentIndexInChildren (mission: MissionModel | null, currentChildren: MissionModel[]): number {
  return currentChildren.findIndex((m: MissionModel) => m.uuid === mission?.uuid)
}

export function isLastParentMission (mission: MissionModel | null, missionParentList: MissionModel[]): boolean {
  return missionParentList.length === getCurrentIndexInGameMissions(mission, missionParentList) + 1
}

export function isLastChildMission (mission: MissionModel | null, currentChildren: MissionModel[]): boolean {
  return currentChildren.length === getCurrentIndexInChildren(mission, currentChildren) + 1
}

export function findParentByChild (mission: MissionModel, missionParentList: any): MissionModel {
  let currentParentByChild: MissionModel = {} as MissionModel

  missionParentList.missions.forEach((parent: MissionModel) => {
    if (parent.childMissions.length <= 0) return
    const findChild = parent.childMissions.find(m => m.uuid === mission.uuid)
    if (findChild) {
      currentParentByChild = parent
    }
  })

  return currentParentByChild
}

export function replaceInstructionsTags ({ mission, points }: IReplaceInstructionsTags): string {
  let textTransformed = replaceTag(mission.instructions, '{{NomeDoTime}}', getTeam()?.name)
  textTransformed = replaceTag(textTransformed, '{{Pontos}}', String(points))
  return textTransformed
}

export function orderByPosition (a:MissionModel, b:MissionModel) {
  if (a.position < b.position) {
    return -1
  }
  if (a.position > b.position) {
    return 1
  }
  return 0
}

export function orderById (a:any, b:any) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}

export function addAllowFullScreen (text:string) {
  if (text.includes('<iframe')) {
    const idx = text.indexOf('<iframe ') + 7
    return text.slice(0, idx) + ' allowfullscreen ' + text.slice(idx)
  }
  return text
}

export function getMissionTimeInSeconds (time:string = '00:00:00') {
  if (!time) return null
  const arrayTime = time?.split(':')
  const seconds = (Number(arrayTime[0]) * 3600) + Number(arrayTime[1]) * 60 + Number(arrayTime[2])
  return seconds
}

export function selectedColors (opacidade = 1) {
  const randomRGBColor = `${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}`

  return `rgba(${randomRGBColor}, ${opacidade})`
}

export const useMousePosition = () => {
  const [
    mousePosition,
    setMousePosition
  ] = useState({ x: 0, y: 0 })
  useEffect(() => {
    const updateMousePosition = (ev:any) => {
      const container = document.getElementById('containerOptions')

      if (container) {
        const rect = container.getBoundingClientRect()
        const localX = ev.pageX - rect.left - window.scrollX
        const localY = ev.pageY - rect.top - window.scrollY

        setMousePosition({ x: localX, y: localY })
      }
    }
    window.addEventListener('mousemove', updateMousePosition)
    return () => {
      window.removeEventListener('mousemove', updateMousePosition)
    }
  }, [])
  return mousePosition
}
